import { render, staticRenderFns } from "./CustomListItem.vue?vue&type=template&id=5d4fff74&scoped=true&lang=pug"
import script from "./CustomListItem.vue?vue&type=script&lang=js"
export * from "./CustomListItem.vue?vue&type=script&lang=js"
import style0 from "./CustomListItem.vue?vue&type=style&index=0&id=5d4fff74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fff74",
  null
  
)

export default component.exports